import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import {
  Close as CloseIcon,
  Lock as LockIcon,
} from '@mui/icons-material';
import styled from 'styled-components';

const StyledDialog = styled(Dialog)`
  .MuiPaper-root {
    border-radius: 16px;
    max-width: 450px;
    width: 90%;
  }
`;

const HeaderSection = styled(Box)`
  text-align: center;
  padding: 24px 24px 16px 24px;
  background: linear-gradient(135deg, #275AA6 0%, #1e4a8c 100%);
  color: white;
  position: relative;
`;

const ContentSection = styled(DialogContent)`
  padding: 24px !important;
`;

const GuestPromptModal = ({ open, onClose, featureName }) => {
  const handleSignUp = () => {
    // Navigate to the base auth page
    window.location.href = '/';
  };

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      aria-labelledby="guest-prompt-dialog"
      maxWidth="sm"
      fullWidth
    >
      <HeaderSection>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'white',
          }}
        >
          <CloseIcon />
        </IconButton>
        
        <LockIcon sx={{ fontSize: 48, mb: 1, opacity: 0.9 }} />
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
          Requires an account
        </Typography>
        <Typography variant="body1" sx={{ opacity: 0.9 }}>
          {featureName ? `Access to ${featureName} requires a free account` : 'This feature requires a free account'}
        </Typography>
      </HeaderSection>

      <ContentSection>
        {/* <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Typography variant="h6" gutterBottom color="primary" sx={{ fontWeight: 'medium' }}>
            Create your free account to unlock:
          </Typography>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography variant="body1" sx={{ mb: 1.5, fontWeight: 'medium' }}>
            ✓ Detailed Airport Performance Metrics
          </Typography>
          <Typography variant="body1" sx={{ mb: 1.5, fontWeight: 'medium' }}>
            ✓ Historical Aviation Safety Data
          </Typography>
          <Typography variant="body1" sx={{ mb: 1.5, fontWeight: 'medium' }}>
            ✓ Advanced Analytics and Reports
          </Typography>
          <Typography variant="body1" sx={{ mb: 1.5, fontWeight: 'medium' }}>
            ✓ Custom Data Export Options
          </Typography>
        </Box> */}

        {/* <Box sx={{ 
          mt: 3, 
          p: 2, 
          bgcolor: '#f5f5f5', 
          borderRadius: 2,
          textAlign: 'center'
        }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Already exploring:</strong> NAS-wide Summary (Always Free)
          </Typography>
        </Box> */}
      </ContentSection>

      <DialogActions sx={{ p: 3, pt: 0, flexDirection: 'column', gap: 2 }}>
        <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
          <Button
            onClick={onClose}
            color="inherit"
            sx={{ flex: 1 }}
          >
            Continue as Guest
          </Button>
          <Button
            onClick={handleSignUp}
            variant="contained"
            size="large"
            sx={{
              backgroundColor: '#275AA6',
              '&:hover': { backgroundColor: '#1e4a8c' },
              px: 4,
              py: 1.5,
              fontSize: '16px',
              fontWeight: 'bold',
              flex: 2,
            }}
          >
            Create Free Account
          </Button>
        </Box>
        <Box sx={{ textAlign: 'center', width: '100%' }}>
          <Typography variant="body2" color="text.secondary">
            Already have an account?{' '}
            <Button
              onClick={handleSignUp}
              variant="text"
              size="small"
              sx={{
                color: '#275AA6',
                fontWeight: 'medium',
                textTransform: 'none',
                minWidth: 'auto',
                p: 0,
                fontSize: 'inherit',
                '&:hover': {
                  backgroundColor: 'transparent',
                  textDecoration: 'underline',
                }
              }}
            >
              Sign in here
            </Button>
          </Typography>
        </Box>
      </DialogActions>
    </StyledDialog>
  );
};

export default GuestPromptModal;